import { Danger, InfoCircle, TickCircle } from 'iconsax-react';

import ICON_SIZE, { ICON_COLOR } from '@/constant/icon-size-color';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { SIZE_ENUM } from '@/components/@base/@types';

const SuccessMsg = ({ text }: { text: string }) => (
  <Container
    center
    className='mx-auto min-h-14 w-fit items-start gap-3 rounded-xl border border-success-250 bg-white dark:bg-neutral-900 px-4'
  >
    <TickCircle size={ICON_SIZE.lg} color={ICON_COLOR.success} />
    <Text className='text-justify text-success-250' size={SIZE_ENUM.MD} bold>
      {text}
    </Text>
  </Container>
);

const ErrorMsg = ({ text }: { text: string }) => (
  <Container
    center
    className='mx-auto max-w-[420px] min-h-14 w-fit items-center gap-3 rounded-xl border border-danger-200 bg-white dark:bg-neutral-900 px-4'
  >
    <Danger size={ICON_SIZE.lg} color={ICON_COLOR.danger} />
    <Text className='text-justify text-danger-200' size={SIZE_ENUM.MD} bold>
      {text}
    </Text>
  </Container>
);

const InfoMsg = ({ text }: { text: string }) => (
  <Container
    center
    className='mx-auto min-h-14 w-fit items-start gap-3 rounded-xl border border-info-300 bg-white dark:bg-neutral-900 px-4'
  >
    <InfoCircle size={ICON_SIZE.lg} color={ICON_COLOR.info} />
    <Text className='text-justify text-info-300' size={SIZE_ENUM.MD} bold>
      {text}
    </Text>
  </Container>
);

export { ErrorMsg, InfoMsg, SuccessMsg };
